module.exports = __webpack_public_path__ + "static/media/galerija_2021 (21)-min.3f58cd87.jpg";